export default __webpack_public_path__ + "static/media/thumbnail.f93731fc.png";